import React from "react";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import logo from "assets/images/com_logo.png";

export default function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      <img src={logo} width="320" />
    </Typography>
  );
}
